import {Table, TableContainer, Typography, Grid} from "@mui/material";
import {BetboardTableHeaders} from "../../organisms/BetboardTable/components/BetboardTableHeaders";
import {LoadingRow} from "./LoadingRow";
import React from "react";
import {LoadingSkeleton} from "./LoadingSkeleton";

export const LoadingTable = ({items}: {items?: number}) => {
    return (
        <Grid item container xs={12} md={10} minHeight={'600px'}>
            <TableContainer
                sx={{
                    maxWidth: '96%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '40px',
                    marginTop: '8px'
                }}
            >
                <Typography
                    variant="caption"
                    display="flex"
                    justifyContent="center"
                    mt={3}
                    style={{color: 'grey'}}
                >
                    <LoadingSkeleton height={15} width={75} />
                </Typography>
                <Table
                    sx={{minWidth: 650}}
                    aria-label="simple table"
                >
                    <BetboardTableHeaders sport={'NBA'}/>
                    <LoadingRow />
                </Table>
            </TableContainer>
        </Grid>
    )
}